import { FilterTypes } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import {
	PurchaseOrder,
	PurchaseOrderFilterFields,
	PurchaseOrderMainSearchFields
} from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getMainSearchConfig = (): PurchaseOrder.Search.Config => ({
	[PurchaseOrderMainSearchFields.searchByPOId]: {
		label: i18n.t('pages:purchaseOrders.filters.purchaseOrderId'),
		apiFieldName: PurchaseOrderMainSearchFields.searchByPOId,
		apiSearchFieldName: 'id',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.poId,
		UrlParamLabel: UrlParamsLabel.poIdLabel
	},
	[PurchaseOrderMainSearchFields.searchByPONumber]: {
		label: i18n.t('pages:purchaseOrders.filters.purchaseOrderNumber'),
		apiFieldName: PurchaseOrderMainSearchFields.searchByPONumber,
		apiSearchFieldName: 'id',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.poNumber,
		UrlParamLabel: UrlParamsLabel.poNumberLabel
	}
})

export const getFiltersConfig = (): PurchaseOrder.Filter.Config => ({
	[PurchaseOrderFilterFields.serviceSiteId]: {
		label: `${i18n.t('pages:purchaseOrders.filters.serviceSite')}:`,
		apiFilterFieldName: PurchaseOrderFilterFields.serviceSiteId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	},
	[PurchaseOrderFilterFields.statusId]: {
		label: `${i18n.t('pages:purchaseOrders.filters.status')}:`,
		apiFilterFieldName: PurchaseOrderFilterFields.statusId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.statusId,
		defaultValue: ''
	}
})
